export default __webpack_public_path__ + "static/media/chatIcon-filled.8f95ca1e.svg";